import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Building2, Search } from "lucide-react";
import { CONVERSATIONS, THREAD } from "@/data/demo";
import { useAuth } from "@/lib/auth";
import { Avatar, Card, PageHeader } from "@/components/common";
import { ChatThread } from "@/components/ChatThread";

const threadFor = (name) => THREAD.map((m) => (m.from === "client" ? { ...m, name } : m));

const Inbox = () => (
  <div>
    <PageHeader title="Messages" subtitle="Conversations with your clients" />
    <div className="relative mb-4">
      <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
      <input data-testid="message-search-input" placeholder="Search conversations" className="h-12 w-full rounded-xl border border-slate-200 bg-white pl-11 pr-4 text-sm outline-none focus:border-amber-400 focus:ring-4 focus:ring-amber-100" />
    </div>
    <Card data-testid="inbox-list" className="divide-y divide-slate-100 overflow-hidden">
      {CONVERSATIONS.map((c) => (
        <Link key={c.id} to={`/messages/${c.id}`} data-testid={`conversation-${c.id}`} className="flex items-center gap-3 p-4 transition-colors hover:bg-slate-50">
          <Avatar name={c.name} />
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2"><span className="truncate font-semibold text-navy">{c.name}</span><span className="shrink-0 text-xs text-slate-400">{c.time}</span></div>
            <div className="mt-0.5 flex items-center justify-between gap-2">
              <span className={`truncate text-sm ${c.unread ? "font-medium text-slate-700" : "text-slate-500"}`}>{c.last}</span>
              {c.unread > 0 && <span className="grid h-5 min-w-[20px] shrink-0 place-items-center rounded-full bg-gold px-1.5 text-[11px] font-bold text-white">{c.unread}</span>}
            </div>
          </div>
        </Link>
      ))}
    </Card>
  </div>
);

const ThreadHeader = ({ name, sub, back }) => (
  <div className="mb-4 flex items-center gap-3">
    {back && <Link to="/messages" data-testid="back-to-inbox" className="grid h-11 w-11 place-items-center rounded-xl text-slate-500 hover:bg-slate-100"><ArrowLeft size={18} /></Link>}
    {back ? <Avatar name={name} /> : <div className="grid h-11 w-11 place-items-center rounded-full bg-navy text-gold"><Building2 size={18} /></div>}
    <div><div data-testid="thread-title" className="font-heading text-lg font-semibold text-navy">{name}</div><div className="text-xs text-emerald-600">{sub}</div></div>
  </div>
);

export default function Messages() {
  const { id } = useParams();
  const { user } = useAuth();
  if (user.user_type === "client") {
    return (
      <div>
        <ThreadHeader name="Adv. Demo Lawyer's Office" sub="Usually replies within a few hours" />
        <ChatThread initial={THREAD} />
      </div>
    );
  }
  if (!id) return <Inbox />;
  const conv = CONVERSATIONS.find((c) => c.id === id) || CONVERSATIONS[0];
  return (
    <div>
      <ThreadHeader name={conv.name} sub="Client" back />
      <ChatThread key={conv.id} initial={threadFor(conv.name)} />
    </div>
  );
}
